var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-footer"},[_c('p',{staticClass:"ac f13 c9"},[_c('span',{staticClass:"item"},[_c('a',{staticClass:"f-under",attrs:{"target":"_blank","rel":"nofollow","href":"https://beian.miit.gov.cn/"}},[_vm._v("鄂ICP备2025089731号-1")])])])])
}]

export { render, staticRenderFns }